import { render, staticRenderFns } from "./ReportSettings.vue?vue&type=template&id=c3a56520&scoped=true"
import script from "./ReportSettings.vue?vue&type=script&lang=js"
export * from "./ReportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a56520",
  null
  
)

export default component.exports